<h1 class="hvac-modal-title">
    <ng-content></ng-content>
</h1>
